export default __webpack_public_path__ + "static/media/books-44.49254799.jpg";